import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
export const useStorefrontStore = create(set => ({
  isCartModalOpen: false,
  openCartModal: () => set({
    isCartModalOpen: true
  }),
  closeCartModal: () => set({
    isCartModalOpen: false
  })
}));
export const useCartModal = () => {
  return useStorefrontStore(useShallow(_temp));
};
function _temp(store) {
  return {
    isCartModalOpen: store.isCartModalOpen,
    openCartModal: store.openCartModal,
    closeCartModal: store.closeCartModal
  };
}